import React from "react";
import { Section } from "./primitives";
import { perimeter as P } from "../mock/inferraData";

const INK = "#16221c";
const LINE = "#2a3a31";
const MUTE = "#9aa8a0";
const GREEN = "#7ccbb5";
const GOLD = "#d2b173";

export default function Perimeter() {
  return (
    <Section id="perimeter" bg="var(--sage)" pt={150} pb={150}>
      <div className="pm-head" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 70 }}>
        <h2 className="font-type reveal" style={{ margin: 0, maxWidth: 560, fontSize: "clamp(32px,4.4vw,58px)", fontWeight: 700, lineHeight: 1.03, letterSpacing: "-1.4px" }}>
          {P.heading}
        </h2>
        <p className="reveal d1" style={{ margin: 0, maxWidth: 460, fontSize: 17, lineHeight: 1.62, color: "var(--ink-soft)" }}>
          {P.body}
        </p>
      </div>

      <div className="pm-diagram reveal" style={{ marginTop: 70, display: "flex", alignItems: "center", gap: 0 }}>
        <div style={{ width: 260, flexShrink: 0, padding: 24, borderRadius: 14, background: INK, border: `1px solid ${LINE}`, color: "#e7ece8", display: "flex", flexDirection: "column", gap: 10 }}>
          <span style={{ fontSize: 13, color: MUTE }}>{P.foundry.label}</span>
          <span style={{ fontSize: 18, fontWeight: 600, lineHeight: 1.3 }}>{P.foundry.title}</span>
        </div>

        <div className="pm-arrow" style={{ width: 180, flexShrink: 0, display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
          <svg width="150" height="24" viewBox="0 0 150 24" aria-hidden="true">
            <line x1="4" y1="12" x2="136" y2="12" stroke={GOLD} strokeWidth="2" strokeDasharray="6 6" style={{ animation: "dash-move 5s linear infinite" }} />
            <path d="M134 5l10 7-10 7" fill="none" stroke={GOLD} strokeWidth="2" />
          </svg>
          <span style={{ fontSize: 13, color: "#8a6a1e" }}>{P.arrow}</span>
        </div>

        <div style={{ flexGrow: 1, padding: 28, borderRadius: 18, border: `1.5px solid ${LINE}`, background: "#13201a", color: "#e7ece8", display: "flex", flexDirection: "column", gap: 20 }}>
          <div className="pm-dc-head" style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
            <span style={{ fontSize: 14, fontWeight: 600 }}>{P.dc.title}</span>
            <span style={{ fontSize: 13, color: MUTE }}>{P.dc.note}</span>
          </div>
          <div className="pm-prod" style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0,1fr))", gap: 10, fontSize: 14 }}>
            {P.dc.products.map((p) => (
              <div key={p} style={{ padding: 14, borderRadius: 10, background: "#17202a", textAlign: "center" }}>{p}</div>
            ))}
          </div>
          <div style={{ padding: 16, borderRadius: 10, border: `1px dashed #3a5a52`, color: GREEN, fontSize: 14 }}>{P.dc.stay}</div>
        </div>
      </div>

      <div className="pm-cols reveal d1" style={{ marginTop: 60, display: "grid", gridTemplateColumns: "repeat(3, minmax(0,1fr))", gap: 48 }}>
        {P.cols.map((c) => (
          <div key={c.h} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <span style={{ fontSize: 17, fontWeight: 700 }} className="font-type">{c.h}</span>
            <span style={{ fontSize: 15, lineHeight: 1.55, color: "var(--ink-soft)" }}>{c.b}</span>
          </div>
        ))}
      </div>

      <style>{`
        @media (max-width: 980px) {
          .pm-head { flex-direction: column; align-items: flex-start; gap: 20px; }
          .pm-diagram { flex-direction: column; align-items: stretch; gap: 18px; }
          .pm-arrow { width: 100%; flex-direction: row; justify-content: center; transform: rotate(90deg); height: 40px; }
          .pm-cols { grid-template-columns: 1fr; gap: 28px; }
        }
        @media (max-width: 560px) { .pm-prod { grid-template-columns: repeat(2, minmax(0,1fr)); } }
      `}</style>
    </Section>
  );
}
